import MajorList from './MajorList';

export default MajorList; 